export type AssignedRecordType =
    | "audit"
    | "issue"
    | "promotion"
    | "riskEvaluation"
    | "task";

export interface RecordTypeBadge {
    styleClass: string;
    label: string;
    untitledTitle: string;
}

export const RECORD_TYPE_BADGES: Readonly<
    Record<AssignedRecordType, RecordTypeBadge>
> = {
    audit: {
        styleClass: "type-badge type-audit",
        label: "Audit",
        untitledTitle: "Untitled Audit",
    },
    issue: {
        styleClass: "type-badge type-case",
        label: "Case",
        untitledTitle: "Untitled Case",
    },
    promotion: {
        styleClass: "type-badge type-promotion",
        label: "Promotion",
        untitledTitle: "Untitled Promotion",
    },
    riskEvaluation: {
        styleClass: "type-badge type-evaluation",
        label: "Evaluation",
        untitledTitle: "Untitled Risk Evaluation",
    },
    task: {
        styleClass: "type-badge type-task",
        label: "Task",
        untitledTitle: "Untitled Task",
    },
};
